import { Component } from "react";
import { message, PageHeader, Spin, Upload, Row, Col, Alert, Switch, Checkbox, Collapse, Select } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import { TableItem, ButtonItem } from "../../../../Components/Items";
import TableItemDinamico from "../../../../Components/TableItemDinamico";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx-js-style";
import { encodeId, decodeId } from "../../../../Components/idEncoder";
import ModalProgreso from "../../../../Components/ModalProgreso";
import SeguidorProcesoMasivo from "../../../../Components/seguirProcesoMasivo";


const CAMPO_TEXTO = {
  Clave: "clave",
  "Codigo Barras": "codigoBarras",
  Descripcion: "descripcion",
  "Descripcion Larga": "descripcionLarga",
  "Descripcion Web": "descripcionWeb",
  "Codigo Proveedor": "codigoProveedor",
  "Cuenta Predial": "cuentaPredial",
  Dimensiones: "dimensiones",
  "Descripcion Materia": "descripcionMateria",
};
const TEXTO_SIN_VALIDACION_PATRON = new Set(["Descripcion Web"]);

const CAMPO_BOOL = {
  Inventariable: "inventariable",
  Lotes: "lotesCaducidades",
  Compra: "compra",
  Venta: "venta",
  "Venta en Linea": "ventaOnline",
  "Ver Insumo Venta": "verInsumoVenta",
  Leyenda: "leyendaVenta",
  Observaciones: "observacionesVenta",
  "Insumo Cambio": "insumoCambio",
  "Segundo Ticket": "segundoTicket",
  "No Facturable": "noFacturable",
  "Cargar Imagen": "cargarImagen",
  "Tolerancia Recepcion": "toleranciaRecepcion",
  "Activar Cuenta Predial": "activarCuentaPredial",
};

const CAMPO_NUMERO = {
  "Compra Minima": "catidadMinCompra",
  "Valor Tolerancia": "valorToleranciaRecepcion",
  "Peso KGM": "pesoEnKGM",
  "Peso Bruto": "pesoBruto",
  "Peso Neto": "pesoNeto",
  "Peso Tara": "pesoTara",
};

const TOLERANCIA_LABELS = { 1: "Porcentaje", 2: "Cantidad Fija" };
const CAMPO_ENUM_NUM = {
  "Tipo Tolerancia": { campo: "tipoToleranciaRecepcion", labels: TOLERANCIA_LABELS },
};

const nombreProveedor = (p) => ((p?.persona ? p?.razonSocial : p?.nombre) || "");

const CATALOGOS_CONFIG = [
  { col: "Unidad", campo: "unidadId", stateKey: "todasUnidades", getNombre: (u) => u?.nombre || "" },
  { col: "Familia", campo: "familiaId", stateKey: "todasFamilias", getNombre: (f) => f?.nombre || "" },
  { col: "Tipo de Insumo", campo: "tipoDeInsumoId", stateKey: "todosTiposDeInsumo", getNombre: (t) => t?.nombre || "" },
  { col: "Marca", campo: "marcaId", stateKey: "todosMarcas", getNombre: (m) => m?.nombre || "" },
  { col: "Proveedor Default", campo: "proveedorDefaultId", stateKey: "todosProveedores", getNombre: nombreProveedor },
];

const COLS_REQUERIDAS = new Set(["Descripcion", "Familia", "Unidad"]);

const TODAS_EDITABLES_BASE = [
  ...Object.keys(CAMPO_TEXTO),
  ...Object.keys(CAMPO_BOOL),
  ...Object.keys(CAMPO_NUMERO),
  ...Object.keys(CAMPO_ENUM_NUM),
  ...CATALOGOS_CONFIG.map((c) => c.col),
  "Costo",
  "Codigo SAT",
  "Impuesto1",
  "Impuesto2",
  "Retencion1",
  "Retencion2",
];

const GRUPOS = [
  {
    key: "generales",
    label: "Generales",
    color: "595959",
    fijo: true,
    columnas: ["ID", "Clave", "Codigo Barras", "Descripcion", "Unidad", "Costo"],
  },
  {
    key: "generalesExtras",
    label: "Generales Extras",
    color: "2F54EB",
    columnas: ["Descripcion Larga", "Descripcion Web", "Codigo Proveedor", "Marca"],
  },
  {
    key: "fiscales",
    label: "Fiscales",
    color: "1890FF",
    columnas: ["Familia", "Tipo de Insumo", "Codigo SAT", "Impuesto1", "Impuesto2", "Retencion1", "Retencion2"],
  },
  {
    key: "ventaCompra",
    label: "Venta y Compra",
    color: "52C41A",
    columnas: ["Compra", "Venta", "Venta en Linea", "Inventariable", "Lotes"],
  },
  {
    key: "listaPrecios",
    label: "Lista de Precios",
    color: "FA8C16",
    columnas: [],
  },
  {
    key: "complementos",
    label: "Complementos",
    color: "722ED1",
    columnas: [
      "Ver Insumo Venta",
      "Leyenda",
      "Observaciones",
      "Insumo Cambio",
      "Segundo Ticket",
      "No Facturable",
      "Cargar Imagen",
      "Proveedor Default",
      "Compra Minima",
      "Tolerancia Recepcion",
      "Tipo Tolerancia",
      "Valor Tolerancia",
      "Activar Cuenta Predial",
      "Cuenta Predial",
    ],
  },
  {
    key: "categorias",
    label: "Categorías",
    color: "EB2F96",
    columnas: [],
  },
  {
    key: "envio",
    label: "Envío",
    color: "13C2C2",
    columnas: [
      "Dimensiones",
      "Descripcion Materia",
      "Peso KGM",
      "Peso Bruto",
      "Peso Neto",
      "Peso Tara",
    ],
  },
];
const GRUPOS_OPCIONALES = GRUPOS.filter((g) => !g.fijo);
const GRUPOS_OPCIONALES_DEFAULT = new Set(GRUPOS_OPCIONALES.map((g) => g.key));

// ── Ejemplos de llenado por columna, para la hoja "Ejemplos" ────────────────
const EJEMPLOS_POR_COLUMNA = {
  ID: ["No modificar (se genera al descargar)"],
  Clave: ["INS-0001", "TOR-HEX-12"],
  "Codigo Barras": ["7501234567890"],
  Descripcion: ["Tornillo hexagonal 1/2 pulg", "Playera de algodón talla M"],
  Unidad: ["Pieza", "Caja", "Kilogramo"],
  Costo: ["125.50", "1200"],
  "Descripcion Larga": ["Tornillo hexagonal galvanizado de 1/2 pulgada, cabeza redonda"],
  "Descripcion Web": ["<b>Tornillo</b> de alta resistencia"],
  "Codigo Proveedor": ["PROV-4521"],
  Marca: ["Truper", "3M"],
  Familia: ["Ferretería", "Tornillería"],
  "Tipo de Insumo": ["Materia Prima", "Consumible"],
  "Codigo SAT": ["25101514", "31191500"],
  Impuesto1: ["IVA 16%"],
  Impuesto2: ["IEPS 8%"],
  Retencion1: ["ISR 10%"],
  Retencion2: ["IVA 10.6667%"],
  Inventariable: ["SI", "NO"],
  Lotes: ["SI", "NO"],
  Compra: ["SI", "NO"],
  Venta: ["SI", "NO"],
  "Venta en Linea": ["SI", "NO"],
  "Precio (nivel de precio)": ["199.99", "1500"],
  "Ver Insumo Venta": ["SI", "NO"],
  Leyenda: ["SI", "NO"],
  Observaciones: ["SI", "NO"],
  "Insumo Cambio": ["SI", "NO"],
  "Segundo Ticket": ["SI", "NO"],
  "No Facturable": ["SI", "NO"],
  "Cargar Imagen": ["SI", "NO"],
  "Proveedor Default": ["Distribuidora ABC SA de CV", "Juan Pérez Herramientas"],
  "Compra Minima": ["10", "5.5"],
  "Tolerancia Recepcion": ["SI", "NO"],
  "Tipo Tolerancia": ["Porcentaje", "Cantidad Fija"],
  "Valor Tolerancia": ["5", "2.5"],
  "Activar Cuenta Predial": ["SI", "NO"],
  "Cuenta Predial": ["1234567890"],
  "Categoria (dinámica)": ["(valor exacto de la hoja Catalogo Categorias)"],
  Dimensiones: ["59/40/36plg"],
  "Descripcion Materia": ["Solvente inflamable"],
  "Peso KGM": ["12.5"],
  "Peso Bruto": ["25"],
  "Peso Neto": ["20"],
  "Peso Tara": ["5"],
};
// Columnas efectivas de un grupo (estáticas o dinámicas).
const columnasDeGrupo = (g, { todasPrecios, todasCategorias }) => {
  if (g.key === "listaPrecios") {
    return (todasPrecios || [])
      .map((p) => `Precio ${(p.nombre || "").trim()}`)
      .filter((c) => c !== "Precio ");
  }
  if (g.key === "categorias") {
    return (todasCategorias || [])
      .filter((c) => !c.esPrincipal)
      .map((c) => (c.nombre || "").trim())
      .filter(Boolean);
  }
  return g.columnas;
};

const renderListaCampos = (campos) =>
  campos.length ? (
    <ul style={{ margin: 0, paddingLeft: 18, maxWidth: 260 }}>
      {campos.map((c) => (
        <li key={c}>{c}</li>
      ))}
    </ul>
  ) : (
    <span style={{ color: "#8c8c8c" }}>Sin campos configurados</span>
  );

// Grupo al que pertenece una columna.
const grupoDeColumna = (col, state) =>
  GRUPOS.find((g) => columnasDeGrupo(g, state).includes(col)) || null;

const ejemplosParaColumna = (col, categoriasFiltradas) => {
  if (EJEMPLOS_POR_COLUMNA[col]) return EJEMPLOS_POR_COLUMNA[col];
  if (col.startsWith("Precio ")) return EJEMPLOS_POR_COLUMNA["Precio (nivel de precio)"];
  if (categoriasFiltradas.some((c) => (c.nombre || "").trim() === col)) {
    return EJEMPLOS_POR_COLUMNA["Categoria (dinámica)"];
  }
  return [];
};

const PATRON_STRING = /^[A-Za-z0-9\n.: ,"'´`¨=ø$#°ºªáÁéÉíÍóÓúÚüÜñÑ@_/*+%&()!-_{¼³®™©Ø}–—“”‘’ ]*$/;

const boolStr = (v) => (v ? "SI" : "NO");
const boolVal = (v) => {
  const s = String(v).trim().toLowerCase();
  if (s === "si" || s === "sí") return true;
  if (s === "no") return false;
  return null;
};
const parseNumero = (val) => Number(String(val).replace(/\$\s?|(,*)/g, ""));

const aclararColor = (hex, factor) => {
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const mix = (c) => Math.round(c + (255 - c) * factor);
  const toHex = (c) => c.toString(16).padStart(2, "0").toUpperCase();
  return `${toHex(mix(r))}${toHex(mix(g))}${toHex(mix(b))}`;
};

const BORDE_FINO = {
  top: { style: "thin", color: { rgb: "C0C0C0" } },
  bottom: { style: "thin", color: { rgb: "C0C0C0" } },
  left: { style: "thin", color: { rgb: "C0C0C0" } },
  right: { style: "thin", color: { rgb: "C0C0C0" } },
};
const estiloBannerGrupo = (color) => ({
  fill: { fgColor: { rgb: color } },
  font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11, name: "Arial" },
  alignment: { horizontal: "center", vertical: "center" },
  border: BORDE_FINO,
});
const estiloEncabezadoColumna = (color) => ({
  fill: { fgColor: { rgb: aclararColor(color, 0.75) } },
  font: { bold: true, sz: 10, name: "Arial" },
  alignment: { horizontal: "center", vertical: "center", wrapText: true },
  border: BORDE_FINO,
});

const obtenerValorColumna = (ins, col, ctx) => {
  if (col === "ID") return encodeId(String(ins._id));
  if (col === "Costo") return ins.costo ?? "";

  if (col === "Codigo SAT") return ins.codigoSatId?.c_ClaveProdServ || "";

  if (col === "Impuesto1" || col === "Impuesto2") {
    const nombres = (ins.impuestos || [])
      .map((imp) => ctx.todasImpuestos.find((i) => String(i._id) === String(imp.impuestoId || imp))?.nombre)
      .filter(Boolean);
    return (col === "Impuesto1" ? nombres[0] : nombres[1]) || "";
  }

  if (col === "Retencion1" || col === "Retencion2") {
    const nombres = (ins.retenciones || [])
      .map((ret) => ctx.todasRetenciones.find((r) => String(r._id) === String(ret.retencionId || ret))?.nombre)
      .filter(Boolean);
    return (col === "Retencion1" ? nombres[0] : nombres[1]) || "";
  }

  if (col.startsWith("Precio ")) {
    const nombreNivel = col.replace(/^Precio /, "");
    const nivel = ctx.todasPrecios.find((p) => (p.nombre || "").trim() === nombreNivel);
    if (!nivel) return "";
    const p = (ins.precios || []).find((px) => String(px.precioId) === String(nivel._id));
    return p !== undefined ? p.precio : "";
  }

  if (CAMPO_TEXTO[col] !== undefined) return ins[CAMPO_TEXTO[col]] || "";
  if (CAMPO_BOOL[col] !== undefined) return boolStr(ins[CAMPO_BOOL[col]]);
  if (CAMPO_NUMERO[col] !== undefined) return ins[CAMPO_NUMERO[col]] ?? "";
  if (CAMPO_ENUM_NUM[col] !== undefined) {
    const { campo, labels } = CAMPO_ENUM_NUM[col];
    return labels[ins[campo]] || "";
  }

  const cat = CATALOGOS_CONFIG.find((c) => c.col === col);
  if (cat) return cat.getNombre(ins[cat.campo]) || "";

  const catDinamica = ctx.categoriasFiltradas.find((c) => (c.nombre || "").trim() === col);
  if (catDinamica) {
    const entrada = (ins.datosCategorias || []).find(
      (dc) => String(dc.categoriaInsumoId?._id || dc.categoriaInsumoId) === String(catDinamica._id)
    );
    return entrada?.valorCategoriaInsumoId?.valor || "";
  }

  return "";
};

const COLUMNAS_PREVIEW = [
  { title: "Clave", dataIndex: "clave", key: "clave", width: 140, sorter: true },
  { title: "Descripción", dataIndex: "descripcion", key: "descripcion", sorter: true },
  {
    title: "Familia",
    key: "familia",
    width: 180,
    render: (_, r) => r.familiaId?.nombre || "",
  },
  {
    title: "Tipo de Insumo",
    key: "tipoDeInsumo",
    width: 180,
    render: (_, r) => r.tipoDeInsumoId?.nombre || "",
  },
  {
    title: "Unidad",
    key: "unidad",
    width: 120,
    render: (_, r) => r.unidadId?.nombre || "",
  },
  {
    title: "Costo",
    dataIndex: "costo",
    key: "costo",
    width: 100,
    align: "right",
    sorter: true,
    render: (v) => (v ?? ""),
  },
];

class EdicionMasivaInsumos extends Component {
  state = {
    loading: false,
    insumosMap: {},
    todasFamilias: [],
    todasUnidades: [],
    todosMarcas: [],
    todasImpuestos: [],
    todasRetenciones: [],
    todasPrecios: [],
    todosCodigosSAT: [],
    todasCategorias: [],
    todosValoresCategorias: [],
    todosProveedores: [],
    todosTiposDeInsumo: [],
    gruposSeleccionados: GRUPOS_OPCIONALES_DEFAULT,
    filtrosExternos: { familiaIds: [], tipoDeInsumoIds: [] },
    previewIniciado: false,
    previewData: [],
    previewTotal: 0,
    previewLoading: false,
    archivosExcel: [],
    data: [],
    columnasPresentes: [],
    columnasCategorias: [],
    archivoError: null,
    errores: 0,
    soloConCambios: true,
    sinIdError: false,
    erroresBackend: [],
    guardando: false,
    progreso: { procesados: 0, total: null },
  };

  componentDidMount() {
    // El guardado corre en el servidor por lotes y avisa por WebSocket: con miles
    // de renglones, una petición HTTP esperando todo el rato se cae por timeout.
    this.seguidor = new SeguidorProcesoMasivo({
      empresaId: this.props.empresaId,
      headersToken: this.props.headersToken,
      onProgreso: (progreso) => this.setState({ guardando: true, progreso }),
      onFin: (resumen) => {
        this.setState({ guardando: false, progreso: { procesados: 0, total: null } });
        // Sin resumen el proceso terminó pero no dejó números (murió, o caducó
        // su resultado): se cierra sin anunciar cifras inventadas ni salirse de
        // la pantalla, para que el usuario pueda revisar y reintentar.
        if (!resumen) return;
        const erroresBackend = resumen.errores || [];
        if (erroresBackend.length) {
          message.warning(
            `Se actualizaron ${resumen.numero ?? 0} insumos. Se omitieron ${erroresBackend.length} por errores.`
          );
          this.setState({ erroresBackend });
        } else {
          message.success(`Se actualizaron ${resumen.numero ?? 0} insumos`);
          this.atras();
        }
      },
      onError: (error) => {
        this.setState({ guardando: false, progreso: { procesados: 0, total: null } });
        message.error(error || "Hubo un error al actualizar los insumos");
      },
    });
    this.seguidor.escuchar();

    this.setState({ loading: true });
    Promise.all([
      axios.post(
        "insumos/datosParaEdicionMasiva",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ),
      axios.post(
        "insumos/datosParaImportar",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ),
    ]).then(([resEdicion, resImportar]) => {
      this.setState({
        todasCategorias: resEdicion.data.success === 2 ? resEdicion.data.categorias || [] : [],
        todosValoresCategorias:
          resEdicion.data.success === 2 ? resEdicion.data.valoresCategorias || [] : [],
        todosProveedores: resEdicion.data.success === 2 ? resEdicion.data.proveedores || [] : [],
        todasFamilias: resImportar.data.success === 2 ? resImportar.data.familias || [] : [],
        todasUnidades: resImportar.data.success === 2 ? resImportar.data.unidades || [] : [],
        todosMarcas: resImportar.data.success === 2 ? resImportar.data.marcas || [] : [],
        todasImpuestos: resImportar.data.success === 2 ? resImportar.data.impuestos || [] : [],
        todasRetenciones: resImportar.data.success === 2 ? resImportar.data.retenciones || [] : [],
        todasPrecios: resImportar.data.success === 2 ? resImportar.data.precios || [] : [],
        todosCodigosSAT: resImportar.data.success === 2 ? resImportar.data.subclases || [] : [],
        todosTiposDeInsumo: resImportar.data.success === 2 ? resImportar.data.tiposDeInsumo || [] : [],
        loading: false,
      });
    });
  }

  componentWillUnmount() {
    if (this.seguidor) this.seguidor.detener();
  }

  atras() {
    this.props.history.goBack();
  }

  consultarPreview(params) {
    // Ignora la consulta automática al montar.
    if (!this.state.previewIniciado) {
      this.setState({ previewLoading: false });
      return;
    }
    this.setState({ previewLoading: true });
    axios
      .post(
        "insumos/insumosPreviewEdicionMasiva",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            previewData: res.data.data || [],
            previewTotal: res.data.totalRecords || 0,
            previewLoading: false,
          });
        } else {
          this.setState({ previewData: [], previewTotal: 0, previewLoading: false });
        }
      });
  }

  actualizarFiltrosPreview(cambios) {
    const filtrosExternos = { ...this.state.filtrosExternos, ...cambios };
    this.setState({ filtrosExternos, previewIniciado: true }, () => {
      if (this.tableRefPreview) this.tableRefPreview.updateExternalFilters(filtrosExternos);
    });
  }

  mostrarTodosPreview() {
    this.setState({ previewIniciado: true }, () => {
      if (this.tableRefPreview) this.tableRefPreview.updateExternalFilters(this.state.filtrosExternos);
    });
  }

  descargarExcel() {
    const { filtrosExternos } = this.state;
    this.setState({ loading: true });
    axios
      .post(
        "insumos/insumosParaExportarEdicionMasiva",
        {
          empresaId: this.props.empresaId,
          familiaIds: filtrosExternos.familiaIds,
          tipoDeInsumoIds: filtrosExternos.tipoDeInsumoIds,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          this.setState({ loading: false });
          message.error("No se pudieron obtener los insumos a exportar");
          return;
        }
        const insumos = res.data.insumos || [];
        if (!insumos.length) {
          this.setState({ loading: false });
          message.warning("No hay insumos para descargar con los filtros seleccionados");
          return;
        }
        const insumosMap = {};
        insumos.forEach((ins) => {
          insumosMap[String(ins._id)] = ins;
        });
        this.setState({ insumosMap, loading: false }, () => {
          this.generarExcel(insumos);
        });
      });
  }

  generarExcel(insumos) {
    const {
      todasImpuestos,
      todasRetenciones,
      todasPrecios,
      todasCategorias,
      todosValoresCategorias,
      todosProveedores,
      gruposSeleccionados,
    } = this.state;

    const categoriasFiltradas = todasCategorias.filter((c) => !c.esPrincipal);

    const gruposActivos = GRUPOS
      .map((g) => ({ ...g, columnas: columnasDeGrupo(g, this.state) }))
      .filter((g) => g.fijo || gruposSeleccionados.has(g.key))
      .filter((g) => g.columnas.length);

    const columnasOrdenadas = gruposActivos.flatMap((g) => g.columnas.map((col) => ({ col, grupo: g })));

    const ctx = { todasImpuestos, todasRetenciones, todasPrecios, categoriasFiltradas };

    const filaGrupos = columnasOrdenadas.map(({ grupo }) => grupo.label);
    const filaColumnas = columnasOrdenadas.map(({ col }) => col);
    const filasDatos = insumos.map((ins) =>
      columnasOrdenadas.map(({ col }) => obtenerValorColumna(ins, col, ctx))
    );

    const ws = XLSX.utils.aoa_to_sheet([filaGrupos, filaColumnas, ...filasDatos]);

    const merges = [];
    let inicio = 0;
    for (let i = 1; i <= columnasOrdenadas.length; i++) {
      if (i === columnasOrdenadas.length || columnasOrdenadas[i].grupo.key !== columnasOrdenadas[inicio].grupo.key) {
        if (i - 1 > inicio) merges.push({ s: { r: 0, c: inicio }, e: { r: 0, c: i - 1 } });
        inicio = i;
      }
    }
    ws["!merges"] = merges;

    columnasOrdenadas.forEach(({ grupo }, idx) => {
      const cellGrupo = XLSX.utils.encode_cell({ r: 0, c: idx });
      const cellCol = XLSX.utils.encode_cell({ r: 1, c: idx });
      if (ws[cellGrupo]) ws[cellGrupo].s = estiloBannerGrupo(grupo.color);
      if (ws[cellCol]) ws[cellCol].s = estiloEncabezadoColumna(grupo.color);
    });

    ws["!cols"] = filaColumnas.map((h) => ({ wch: Math.max(h.length + 2, 15) }));
    ws["!rows"] = [{ hpt: 22 }, { hpt: 26 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Insumos");

    const instrucciones = [
      ["Instrucciones de uso"],
      [""],
      ["1. La columna ID es OBLIGATORIA y NO debe modificarse ni eliminarse."],
      ["2. Las primeras dos filas son encabezados: la fila 1 agrupa las columnas por sección, la fila 2 trae el nombre real de cada columna. No borre ninguna de las dos filas."],
      ["3. Puede BORRAR las columnas que NO desee editar. Solo se modificarán las columnas presentes en el archivo."],
      ["4. Columnas SI/NO: use SI o NO."],
      ["5. Unidad, Familia, Tipo de Insumo, Marca, Impuesto, Retención: escriba exactamente el nombre tal como aparece en su hoja \"Catalogo ...\" correspondiente. Para quitar Marca, Impuesto o Retención, deje la celda vacía."],
      ["6. Proveedor Default: escriba el NOMBRE exacto del proveedor tal como aparece en la columna Nombre de la hoja \"Catalogo Proveedores\" (si descargó el grupo Complementos)."],
      ["7. Tipo Tolerancia: use Porcentaje o Cantidad Fija."],
      [
        "8. Columnas de Categoría: una columna por cada categoría. Escriba el valor exacto que aparece en la hoja \"Catalogo Categorias\" (cada categoría es una columna y debajo aparecen sus valores posibles). Celda vacía = el insumo no tendrá esa categoría asignada.",
      ],
    ];
    const wsInstr = XLSX.utils.aoa_to_sheet(instrucciones);
    wsInstr["!cols"] = [{ wch: 95 }];
    XLSX.utils.book_append_sheet(wb, wsInstr, "Instrucciones");

    const aoaEjemplos = [["Grupo", "Columna", "Ejemplo 1", "Ejemplo 2", "Ejemplo 3"]];
    columnasOrdenadas.forEach(({ col, grupo }) => {
      const ejemplos = ejemplosParaColumna(col, categoriasFiltradas);
      aoaEjemplos.push([grupo.label, col, ejemplos[0] || "", ejemplos[1] || "", ejemplos[2] || ""]);
    });
    const wsEjemplos = XLSX.utils.aoa_to_sheet(aoaEjemplos);
    wsEjemplos["!cols"] = [{ wch: 22 }, { wch: 30 }, { wch: 28 }, { wch: 28 }, { wch: 28 }];
    for (let c = 0; c < 5; c++) {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c });
      if (wsEjemplos[cellRef]) wsEjemplos[cellRef].s = estiloBannerGrupo("595959");
    }
    columnasOrdenadas.forEach(({ grupo }, idx) => {
      const cellGrupo = XLSX.utils.encode_cell({ r: idx + 1, c: 0 });
      if (wsEjemplos[cellGrupo]) {
        wsEjemplos[cellGrupo].s = {
          fill: { fgColor: { rgb: aclararColor(grupo.color, 0.75) } },
          font: { bold: true, sz: 10, name: "Arial" },
        };
      }
    });
    XLSX.utils.book_append_sheet(wb, wsEjemplos, "Ejemplos");

    const columnasIncluidas = new Set(columnasOrdenadas.map((o) => o.col));

    CATALOGOS_CONFIG
      .filter((cfg) => cfg.col !== "Proveedor Default" && columnasIncluidas.has(cfg.col))
      .forEach((cfg) => {
        const lista = this.state[cfg.stateKey] || [];
        if (!lista.length) return;
        const aoaCatalogo = [["Nombre"], ...lista.map((item) => [cfg.getNombre(item)])];
        const wsCatalogo = XLSX.utils.aoa_to_sheet(aoaCatalogo);
        wsCatalogo["!cols"] = [{ wch: 40 }];
        XLSX.utils.book_append_sheet(wb, wsCatalogo, `Catalogo ${cfg.col}`);
      });

    if ((columnasIncluidas.has("Impuesto1") || columnasIncluidas.has("Impuesto2")) && todasImpuestos.length) {
      const aoaImp = [["Nombre"], ...todasImpuestos.map((i) => [i.nombre || ""])];
      const wsImp = XLSX.utils.aoa_to_sheet(aoaImp);
      wsImp["!cols"] = [{ wch: 30 }];
      XLSX.utils.book_append_sheet(wb, wsImp, "Catalogo Impuestos");
    }

    if ((columnasIncluidas.has("Retencion1") || columnasIncluidas.has("Retencion2")) && todasRetenciones.length) {
      const aoaRet = [["Nombre"], ...todasRetenciones.map((r) => [r.nombre || ""])];
      const wsRet = XLSX.utils.aoa_to_sheet(aoaRet);
      wsRet["!cols"] = [{ wch: 30 }];
      XLSX.utils.book_append_sheet(wb, wsRet, "Catalogo Retenciones");
    }

    if (categoriasFiltradas.length && gruposSeleccionados.has("categorias")) {
      const headerCat = categoriasFiltradas.map((c) => (c.nombre || "").trim());
      const valoresPorCategoria = categoriasFiltradas.map((cat) =>
        todosValoresCategorias
          .filter((v) => String(v.categoriaInsumoId) === String(cat._id))
          .map((v) => v.valor || "")
      );
      const maxFilas = Math.max(0, ...valoresPorCategoria.map((vs) => vs.length));
      const aoa = [headerCat];
      for (let i = 0; i < maxFilas; i++) {
        aoa.push(valoresPorCategoria.map((vs) => vs[i] || ""));
      }
      const wsCat = XLSX.utils.aoa_to_sheet(aoa);
      wsCat["!cols"] = headerCat.map((h) => ({ wch: Math.max(h.length + 2, 20) }));
      XLSX.utils.book_append_sheet(wb, wsCat, "Catalogo Categorias");
    }

    if (gruposSeleccionados.has("complementos") && todosProveedores.length) {
      const aoaProv = [
        ["Nombre", "Clave"],
        ...todosProveedores.map((p) => [nombreProveedor(p), p.clave || ""]),
      ];
      const wsProv = XLSX.utils.aoa_to_sheet(aoaProv);
      wsProv["!cols"] = [{ wch: 40 }, { wch: 20 }];
      XLSX.utils.book_append_sheet(wb, wsProv, "Catalogo Proveedores");
    }

    XLSX.writeFile(wb, "edicion_masiva_insumos.xlsx");
  }

  onChangeArchivo(e) {
    this.setState({ loading: true });
    if (
      e.file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      this.setState({
        archivosExcel: [{ ...e.file, name: e.file.name, status: "uploading" }],
      });
      this.cargarArchivoExcel(e.file);
    } else {
      message.error("El archivo debe ser un archivo de Excel (.xlsx)");
      this.setState({ loading: false });
    }
  }

  cargarArchivoExcel(file) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const primeraHoja = workbook.SheetNames[0];
      const filas = XLSX.utils.sheet_to_json(
        workbook.Sheets[primeraHoja],
        { defval: "", range: 1 }
      );
      this.asegurarInsumosMap(filas)
        .then(() => this.procesarFilas(filas))
        .then((result) => {
          this.setState({
            data: result.data,
            columnasPresentes: result.columnasPresentes,
            columnasCategorias: result.columnasCategorias || [],
            errores: result.errores,
            archivoError: result.errores > 0 ? result.archivoErrores : null,
            sinIdError: result.sinIdError,
            archivosExcel: [{ ...file, name: file.name, status: "success" }],
            loading: false,
            erroresBackend: [],
          });
          if (result.sinIdError) {
            message.error(
              "El archivo no contiene la columna ID. Descargue el Excel desde este módulo e intente nuevamente."
            );
          } else if (result.errores > 0) {
            message.warning(
              `Se detectaron ${result.errores} errores. Descargue el archivo de errores para revisarlos.`
            );
          } else {
            const conCambios = result.data.filter((d) => d._hayCambios).length;
            message.success(
              `Archivo leído: ${conCambios} insumo(s) con cambios de ${result.data.length} leídos.`
            );
          }
        });
    };
  }

  // insumosMap sólo se llena al descargar el Excel. Si el archivo que se sube
  // trae algún ID que no está en el mapa (página recargada, archivo de otra
  // sesión, o descargado con un filtro distinto al que se está subiendo), se
  // vuelve a pedir el set completo sin filtros antes de procesar las filas.
  asegurarInsumosMap(filas) {
    const { insumosMap } = this.state;

    const faltaAlguno = filas.some((fila) => {
      const encodedId = String(fila["ID"] || "").trim();
      if (!encodedId) return false;
      const decodedId = decodeId(encodedId);
      return (
        !decodedId ||
        !Object.prototype.hasOwnProperty.call(insumosMap, decodedId)
      );
    });

    if (!faltaAlguno) return Promise.resolve();

    return axios
      .post(
        "insumos/insumosParaExportarEdicionMasiva",
        { empresaId: this.props.empresaId, familiaIds: [], tipoDeInsumoIds: [] },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          message.error(
            "No se pudieron obtener los insumos para validar el archivo"
          );
          return;
        }
        const nuevoMap = {};
        (res.data.insumos || []).forEach((ins) => {
          nuevoMap[String(ins._id)] = ins;
        });
        return new Promise((resolve) => {
          this.setState({ insumosMap: nuevoMap }, resolve);
        });
      })
      .catch(() => {
        message.error(
          "No se pudieron obtener los insumos para validar el archivo"
        );
      });
  }

  async procesarFilas(filas) {
    if (!filas.length)
      return {
        data: [],
        columnasPresentes: [],
        columnasCategorias: [],
        errores: 0,
        sinIdError: false,
        archivoErrores: null,
      };

    const {
      insumosMap,
      todasUnidades,
      todasFamilias,
      todosMarcas,
      todosTiposDeInsumo,
      todasImpuestos,
      todasRetenciones,
      todasPrecios,
      todosCodigosSAT,
      todasCategorias,
      todosValoresCategorias,
      todosProveedores,
    } = this.state;

    const primeraFila = filas[0];
    if (!("ID" in primeraFila)) {
      return {
        data: [],
        columnasPresentes: [],
        columnasCategorias: [],
        errores: 0,
        sinIdError: true,
        archivoErrores: null,
      };
    }

    const precioColumnas = todasPrecios
      .map((p) => `Precio ${(p.nombre || "").trim()}`)
      .filter((c) => c !== "Precio ");
    const TODAS_EDITABLES = [...TODAS_EDITABLES_BASE, ...precioColumnas];
    const columnasPresentes = TODAS_EDITABLES.filter((col) => col in primeraFila);
    const columnasCategorias = todasCategorias
      .filter((c) => !c.esPrincipal)
      .map((c) => (c.nombre || "").trim())
      .filter((n) => n && n in primeraFila);

    // catálogos por stateKey
    const catalogos = {
      todasUnidades,
      todasFamilias,
      todosMarcas,
      todosTiposDeInsumo,
      todosProveedores,
    };

    const erroresRows = [];
    const data = [];
    let errores = 0;

    // ---- DEBUG edición masiva insumos ----
    const clavesMapa = Object.keys(insumosMap);
    console.log("[EdicionMasivaInsumos] insumosMap tiene", clavesMapa.length, "insumos");
    console.log("[EdicionMasivaInsumos] primeras claves del mapa:", clavesMapa.slice(0, 5));
    console.log("[EdicionMasivaInsumos] filas del Excel:", filas.length);
    console.log("[EdicionMasivaInsumos] primera fila:", filas[0]);
    // ---- FIN DEBUG ----

    let yaLogueoFallo = false; // DEBUG: sólo se loguea el primer ID no resuelto

    for (const fila of filas) {
      const encodedId = String(fila["ID"] || "").trim();
      const decodedId = encodedId ? decodeId(encodedId) : null;
      const ins = decodedId ? insumosMap[decodedId] : null;
      if (!encodedId || !ins) {
        // ---- DEBUG edición masiva insumos ----
        if (!yaLogueoFallo) {
          yaLogueoFallo = true;
          console.log("[EdicionMasivaInsumos] PRIMER ID NO RESUELTO", {
            encodedId,
            decodedId,
            largoDecodificado: decodedId ? decodedId.length : null,
            estaEnMapa: decodedId
              ? Object.prototype.hasOwnProperty.call(insumosMap, decodedId)
              : false,
            mapaVacio: clavesMapa.length === 0,
          });
        }
        // ---- FIN DEBUG ----
        errores++;
        erroresRows.push({
          ...fila,
          Errores: !encodedId ? "ID vacío" : `ID no encontrado: ${encodedId}`,
        });
        continue;
      }

      const actual = ins;
      const obj = { insumoId: String(ins._id), _claveOriginal: actual.clave };
      const cambios = [];
      const filaErrores = [];

      let nuevosImpuestos = null;
      let nuevasRetenciones = null;
      let nuevosPreciosParciales = {};

      for (const col of columnasPresentes) {
        const val = String(fila[col] ?? "").trim();

        if (COLS_REQUERIDAS.has(col) && !val) {
          filaErrores.push(`${col}: no puede estar vacío`);
          continue;
        }

        if (col === "Costo") {
          if (val === "") {
            obj._d_Costo = "";
          } else {
            const num = parseNumero(val);
            if (isNaN(num)) {
              filaErrores.push(`Costo: "${val}" no es un número`);
              continue;
            }
            obj.costo = num;
            obj._d_Costo = `$${num}`;
            if (String(actual.costo) !== String(num)) cambios.push(col);
          }
        } else if (col === "Codigo SAT") {
          if (val) {
            if (!/^\d{8}$/.test(val)) {
              filaErrores.push(`Codigo SAT: "${val}" debe ser 8 dígitos`);
              continue;
            }
            const codigoEncontrado = todosCodigosSAT.find(
              (c) => c.c_ClaveProdServ === val
            );
            if (!codigoEncontrado) {
              filaErrores.push(`Codigo SAT: "${val}" no es un código válido`);
              continue;
            }
            obj.codigoSatId = codigoEncontrado._id;
          } else {
            obj.codigoSatId = null;
          }
          obj.codigoSat = val;
          obj["_d_Codigo SAT"] = val;
          if (String(actual.codigoSatId?.c_ClaveProdServ || "") !== val)
            cambios.push(col);
        } else if (col === "Impuesto1" || col === "Impuesto2") {
          if (nuevosImpuestos === null) nuevosImpuestos = [];
          if (val) {
            const found = todasImpuestos.find((i) => i.nombre === val);
            if (!found) {
              filaErrores.push(`${col}: "${val}" no es un impuesto válido`);
              continue;
            }
            nuevosImpuestos.push({ impuestoId: found._id });
          }
        } else if (col === "Retencion1" || col === "Retencion2") {
          if (nuevasRetenciones === null) nuevasRetenciones = [];
          if (val) {
            const found = todasRetenciones.find((r) => r.nombre === val);
            if (!found) {
              filaErrores.push(`${col}: "${val}" no es una retención válida`);
              continue;
            }
            nuevasRetenciones.push({ retencionId: found._id });
          }
        } else if (precioColumnas.includes(col)) {
          const nombreNivel = col.replace(/^Precio /, "");
          const nivel = todasPrecios.find(
            (p) => (p.nombre || "").trim() === nombreNivel
          );
          if (!nivel) continue;
          if (val !== "") {
            const num = parseNumero(val);
            if (isNaN(num)) {
              filaErrores.push(`${col}: "${val}" no es un número`);
              continue;
            }
            nuevosPreciosParciales[String(nivel._id)] = num;
          }
        } else if (CAMPO_TEXTO[col] !== undefined) {
          const campo = CAMPO_TEXTO[col];
          if (val && !TEXTO_SIN_VALIDACION_PATRON.has(col) && !PATRON_STRING.test(val)) {
            filaErrores.push(`${col}: contiene caracteres no aceptados`);
            continue;
          }
          obj[campo] = val;
          obj[`_d_${col}`] = val;
          if (String(actual[campo] || "") !== val) cambios.push(col);
        } else if (CAMPO_BOOL[col] !== undefined) {
          const campo = CAMPO_BOOL[col];
          const bv = boolVal(val);
          if (bv === null) {
            filaErrores.push(`${col}: valor inválido "${val}" (use SI o NO)`);
            continue;
          }
          obj[campo] = bv;
          obj[`_d_${col}`] = bv ? "SI" : "NO";
          if (bv !== !!actual[campo]) cambios.push(col);
        } else if (CAMPO_NUMERO[col] !== undefined) {
          const campo = CAMPO_NUMERO[col];
          if (val === "") {
            obj[campo] = null;
            obj[`_d_${col}`] = "";
            if (actual[campo] != null) cambios.push(col);
          } else {
            const num = parseNumero(val);
            if (isNaN(num)) {
              filaErrores.push(`${col}: "${val}" no es un número`);
              continue;
            }
            obj[campo] = num;
            obj[`_d_${col}`] = String(num);
            if (String(actual[campo] ?? "") !== String(num)) cambios.push(col);
          }
        } else if (CAMPO_ENUM_NUM[col] !== undefined) {
          const { campo, labels } = CAMPO_ENUM_NUM[col];
          if (val === "") {
            obj[campo] = null;
            obj[`_d_${col}`] = "";
            if (actual[campo] != null) cambios.push(col);
          } else {
            const entry = Object.entries(labels).find(
              ([, label]) => label.toLowerCase() === val.toLowerCase()
            );
            if (!entry) {
              filaErrores.push(`${col}: "${val}" inválido (use ${Object.values(labels).join(", ")})`);
              continue;
            }
            const clave = Number(entry[0]);
            obj[campo] = clave;
            obj[`_d_${col}`] = labels[clave];
            if (actual[campo] !== clave) cambios.push(col);
          }
        } else {
          const cfg = CATALOGOS_CONFIG.find((c) => c.col === col);
          if (!cfg) continue;
          const lista = catalogos[cfg.stateKey] || [];
          if (val === "") {
            obj[cfg.campo] = null;
            obj[`_d_${col}`] = "";
            if (actual[cfg.campo]) cambios.push(col);
            continue;
          }
          const encontrado = lista.find(
            (item) => String(cfg.getNombre(item) ?? "").trim() === val
          );
          if (!encontrado) {
            filaErrores.push(`${col}: "${val}" no encontrado`);
            continue;
          }
          obj[cfg.campo] = encontrado._id;
          obj[`_d_${col}`] = val;
          const idActual = String(actual[cfg.campo]?._id || actual[cfg.campo] || "");
          if (idActual !== String(encontrado._id)) cambios.push(col);
        }
      }

      if (nuevosImpuestos !== null) {
        obj.impuestos = nuevosImpuestos;
        obj["_d_Impuesto1"] = nuevosImpuestos[0]
          ? todasImpuestos.find(
              (i) => String(i._id) === String(nuevosImpuestos[0].impuestoId)
            )?.nombre || ""
          : "";
        obj["_d_Impuesto2"] = nuevosImpuestos[1]
          ? todasImpuestos.find(
              (i) => String(i._id) === String(nuevosImpuestos[1].impuestoId)
            )?.nombre || ""
          : "";
        const actualImpIds = (actual.impuestos || [])
          .map((i) => String(i.impuestoId || i))
          .sort()
          .join(",");
        const nuevoImpIds = nuevosImpuestos
          .map((i) => String(i.impuestoId))
          .sort()
          .join(",");
        if (actualImpIds !== nuevoImpIds) cambios.push("Impuesto1");
      }

      if (nuevasRetenciones !== null) {
        obj.retenciones = nuevasRetenciones;
        obj["_d_Retencion1"] = nuevasRetenciones[0]
          ? todasRetenciones.find(
              (r) => String(r._id) === String(nuevasRetenciones[0].retencionId)
            )?.nombre || ""
          : "";
        obj["_d_Retencion2"] = nuevasRetenciones[1]
          ? todasRetenciones.find(
              (r) => String(r._id) === String(nuevasRetenciones[1].retencionId)
            )?.nombre || ""
          : "";
        const actualRetIds = (actual.retenciones || [])
          .map((r) => String(r.retencionId || r))
          .sort()
          .join(",");
        const nuevoRetIds = nuevasRetenciones
          .map((r) => String(r.retencionId))
          .sort()
          .join(",");
        if (actualRetIds !== nuevoRetIds) cambios.push("Retencion1");
      }

      if (Object.keys(nuevosPreciosParciales).length) {
        const preciosArr = Object.entries(nuevosPreciosParciales).map(
          ([precioId, precio]) => ({ precioId, precio })
        );
        obj.precios = preciosArr;
        for (const [precioId, precio] of Object.entries(nuevosPreciosParciales)) {
          const nivel = todasPrecios.find((p) => String(p._id) === precioId);
          if (!nivel) continue;
          const colNombre = `Precio ${(nivel.nombre || "").trim()}`;
          obj[`_d_${colNombre}`] = `$${precio}`;
          const actualP = (actual.precios || []).find(
            (p) => String(p.precioId) === precioId
          );
          if (!actualP || String(actualP.precio) !== String(precio))
            cambios.push(colNombre);
        }
      }

      if (columnasCategorias.length) {
        const nuevasCategorias = [];
        for (const catNombre of columnasCategorias) {
          const cat = todasCategorias.find(
            (c) => (c.nombre || "").trim() === catNombre
          );
          if (!cat) continue;
          const val = String(fila[catNombre] ?? "").trim();
          obj[`_d_${catNombre}`] = val;

          const actualEntrada = (actual.datosCategorias || []).find(
            (dc) =>
              String(dc.categoriaInsumoId?._id || dc.categoriaInsumoId) ===
              String(cat._id)
          );
          const actualValorId = actualEntrada
            ? String(
                actualEntrada.valorCategoriaInsumoId?._id ||
                  actualEntrada.valorCategoriaInsumoId ||
                  ""
              )
            : "";

          if (val === "") {
            if (actualEntrada) cambios.push(catNombre);
            continue;
          }
          const valor = todosValoresCategorias.find(
            (v) =>
              String(v.categoriaInsumoId) === String(cat._id) &&
              String(v.valor ?? "").trim().toLowerCase() === val.toLowerCase()
          );
          if (!valor) {
            filaErrores.push(
              `Valor "${val}" no existe para la categoría "${catNombre}"`
            );
            continue;
          }
          nuevasCategorias.push({
            categoriaInsumoId: cat._id,
            valorCategoriaInsumoId: valor._id,
          });
          if (actualValorId !== String(valor._id)) cambios.push(catNombre);
        }
        obj.datosCategorias = nuevasCategorias;
      }

      if (filaErrores.length) {
        errores++;
        erroresRows.push({ ...fila, Errores: filaErrores.join("; ") });
      } else {
        obj._cambios = cambios;
        obj._hayCambios = cambios.length > 0;
        data.push(obj);
      }
    }

    const archivoEditar = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      archivoEditar,
      XLSX.utils.json_to_sheet(erroresRows),
      "Errores"
    );
    return {
      data,
      columnasPresentes,
      columnasCategorias,
      errores,
      sinIdError: false,
      archivoErrores: archivoEditar,
    };
  }

  descargarArchivoErrores() {
    if (!this.state.archivoError) return;
    const wbout = XLSX.write(this.state.archivoError, {
      bookType: "xlsx",
      type: "binary",
    });
    const s2ab = (s) => {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    };
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = "errores_edicion_masiva.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  onFinish() {
    const dataConCambios = this.state.data.filter((d) => d._hayCambios);
    if (!dataConCambios.length) {
      message.warning("No hay cambios que guardar");
      return;
    }
    const dataParaEnviar = dataConCambios.map((row) => {
      const obj = {};
      for (const key in row) {
        if (
          !key.startsWith("_d_") &&
          key !== "_cambios" &&
          key !== "_hayCambios" &&
          key !== "_claveOriginal"
        ) {
          obj[key] = row[key];
        }
      }
      return obj;
    });

    const columnasParaEnviar = [...this.state.columnasPresentes];
    if (this.state.columnasCategorias.length) columnasParaEnviar.push("Categorias");

    this.setState({ loading: true, erroresBackend: [] });
    axios
      .post(
        "insumos/editarInsumosMasivo",
        {
          empresaId: this.props.empresaId,
          data: dataParaEnviar,
          columnas: columnasParaEnviar,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          if (res.data.success === 1) {
            message.error("No se pudieron actualizar los insumos");
          } else {
            // Incluye el rechazo por candado: ya hay otra operación masiva en
            // curso para esta empresa.
            message.error(res.data.message || "Hubo un error al actualizar los insumos");
          }
          return;
        }

        // Ojo: `numero` todavía no existe aquí. La respuesta sólo confirma que
        // arrancó; los renglones que ni siquiera se intentaron (los que no
        // pasaron la validación previa) sí vienen ya en `errores`.
        if (res.data.total === 0) {
          // No hubo nada que escribir: el backend responde en directo, sin
          // levantar un proceso en background.
          this.setState({ erroresBackend: res.data.errores || [] });
          message.warning(`No hubo insumos que actualizar. Se omitieron ${(res.data.errores || []).length}.`);
          return;
        }

        this.seguidor.seguir(res.data.procesoId);
        this.setState({
          guardando: true,
          progreso: { procesados: 0, total: res.data.total ?? null },
        });
      });
  }

  render() {
    const {
      data,
      columnasPresentes,
      columnasCategorias,
      errores,
      sinIdError,
      soloConCambios,
      erroresBackend,
      gruposSeleccionados,
    } = this.state;

    const totalConCambios = data.filter((d) => d._hayCambios).length;
    const dataMostrar = soloConCambios
      ? data.filter((d) => d._hayCambios)
      : data;

    const columnasClave = [
      {
        title: "Clave Actual",
        dataIndex: "_claveOriginal",
        key: "_claveOriginal",
        fixed: "left",
        width: 100,
      },
    ];

    const renderCelda = (col, grupo) => (_, record) => {
      const val = record[`_d_${col}`] ?? String(record[col] ?? "");
      const changed = record._cambios && record._cambios.includes(col);
      const colorGrupo = grupo?.color;
      return (
        <span
          style={{
            backgroundColor: changed ? (colorGrupo ? `#${aclararColor(colorGrupo, 0.72)}` : "#fff3cd") : undefined,
            borderLeft: changed && colorGrupo ? `3px solid #${colorGrupo}` : undefined,
            padding: changed ? "2px 6px" : undefined,
            borderRadius: changed ? 4 : undefined,
            display: "inline-block",
          }}
        >
          {val}
        </span>
      );
    };

    // Mismo orden y color por grupo que el Excel.
    const indiceGrupo = (g) => (g ? GRUPOS.indexOf(g) : GRUPOS.length);
    const columnasOrdenadas = [
      ...columnasPresentes.map((col) => ({ col, esCategoria: false, grupo: grupoDeColumna(col, this.state) })),
      ...columnasCategorias.map((col) => ({ col, esCategoria: true, grupo: grupoDeColumna(col, this.state) })),
    ].sort((a, b) => indiceGrupo(a.grupo) - indiceGrupo(b.grupo));

    const columnasTabla = columnasOrdenadas.map(({ col, esCategoria, grupo }) => ({
      title: col,
      key: esCategoria ? `cat_${col}` : col,
      width: 150,
      onHeaderCell: () =>
        grupo ? { style: { backgroundColor: `#${aclararColor(grupo.color, 0.85)}` } } : {},
      render: renderCelda(col, grupo),
    }));

    const columns = [...columnasClave, ...columnasTabla];

    const columnasAviso = [...columnasPresentes, ...columnasCategorias];

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Edición Masiva de Insumos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            this.state.archivoError ? (
              <ButtonItem onClick={this.descargarArchivoErrores.bind(this)}>
                Descargar Errores
              </ButtonItem>
            ) : null
          }
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={this.state.loading} tip="Cargando, espere por favor...">
            <Alert
              style={{ marginBottom: 16, marginTop: 10 }}
              type="info"
              showIcon
              message="Instrucciones"
              description={
                <ol style={{ margin: 0, paddingLeft: 20 }}>
                  <li>
                    Filtre por Familia y/o Tipo de Insumo (opcional) para acotar qué
                    insumos va a exportar. Revise la vista previa antes de descargar.
                  </li>
                  <li>Elija qué grupos de datos quiere editar y descargue el Excel.</li>
                  <li>
                    <b>Borre las columnas que NO desee modificar.</b> Solo se
                    actualizarán las columnas que queden en el archivo.
                  </li>
                  <li>
                    La columna <b>ID</b> es obligatoria y no debe eliminarse ni
                    modificarse. Tampoco borre las dos filas de encabezado.
                  </li>
                  <li>
                    Suba el archivo modificado y revise la vista previa antes de
                    guardar.
                  </li>
                </ol>
              }
            />
            <div style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8, fontWeight: 500 }}>
                Filtra qué insumos vas a exportar (opcional)
              </div>
              <Row gutter={12}>
                <Col span={12}>
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Filtrar por Familia"
                    style={{ width: "100%" }}
                    value={this.state.filtrosExternos.familiaIds}
                    onChange={(vals) => this.actualizarFiltrosPreview({ familiaIds: vals })}
                    options={this.state.todasFamilias.map((f) => ({ label: f.nombre, value: f._id }))}
                    optionFilterProp="label"
                  />
                </Col>
                <Col span={12}>
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Filtrar por Tipo de Insumo"
                    style={{ width: "100%" }}
                    value={this.state.filtrosExternos.tipoDeInsumoIds}
                    onChange={(vals) => this.actualizarFiltrosPreview({ tipoDeInsumoIds: vals })}
                    options={this.state.todosTiposDeInsumo.map((t) => ({ label: t.nombre, value: t._id }))}
                    optionFilterProp="label"
                  />
                </Col>
              </Row>
            </div>
            <div style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8, fontWeight: 500 }}>
                Vista previa de lo que se va a descargar
                {this.state.previewIniciado &&
                  ` (${this.state.previewTotal} insumo${this.state.previewTotal !== 1 ? "s" : ""})`}
              </div>
              {this.state.previewIniciado ? (
                <TableItemDinamico
                  ref={(ref) => {
                    this.tableRefPreview = ref;
                  }}
                  onRef={(ref) => {
                    this.tableRefPreview = ref;
                  }}
                  size="small"
                  columns={COLUMNAS_PREVIEW}
                  dataSource={this.state.previewData}
                  totalRecords={this.state.previewTotal}
                  loading={this.state.previewLoading}
                  pagination={false}
                  rowKey="_id"
                  onFetchData={this.consultarPreview.bind(this)}
                />
              ) : (
                <Alert
                  type="info"
                  showIcon
                  message="Elige un filtro de Familia o Tipo de Insumo arriba, o muestra todos los insumos para ver la vista previa."
                  action={
                    <ButtonItem size="small" onClick={this.mostrarTodosPreview.bind(this)}>
                      Mostrar todos
                    </ButtonItem>
                  }
                />
              )}
            </div>
            <div style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8, fontWeight: 500 }}>
                ¿Qué datos quieres editar?
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "flex-start" }}>
                {GRUPOS.map((g) => (
                  <div
                    key={g.key}
                    style={{
                      flex: "1 1 170px",
                      minWidth: 170,
                      display: "flex",
                      flexDirection: "column",
                      background: "#fafafa",
                      border: "1px solid #eaeaea",
                      borderTop: `3px solid #${g.color}`,
                      borderRadius: 6,
                      overflow: "hidden",
                    }}
                  >
                    <div style={{ padding: "8px 12px 4px" }}>
                      {g.fijo ? (
                        <Checkbox checked disabled>
                          {g.label}
                        </Checkbox>
                      ) : (
                        <Checkbox
                          checked={gruposSeleccionados.has(g.key)}
                          onChange={(e) => {
                            const nuevo = new Set(gruposSeleccionados);
                            if (e.target.checked) nuevo.add(g.key);
                            else nuevo.delete(g.key);
                            this.setState({ gruposSeleccionados: nuevo });
                          }}
                        >
                          {g.label}
                        </Checkbox>
                      )}
                    </div>
                    <Collapse ghost size="small">
                      <Collapse.Panel header="Ver campos" key={g.key}>
                        {renderListaCampos(columnasDeGrupo(g, this.state))}
                      </Collapse.Panel>
                    </Collapse>
                  </div>
                ))}
              </div>
            </div>
            <Row style={{ marginBottom: 16, alignItems: "center" }}>
              <Col span={12}>
                <ButtonItem
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={this.descargarExcel.bind(this)}
                >
                  Descargar Excel
                </ButtonItem>
              </Col>
              <Col span={12}>
                <Upload
                  showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                  fileList={this.state.archivosExcel}
                  customRequest={this.onChangeArchivo.bind(this)}
                  accept=".xlsx"
                >
                  <ButtonItem icon={<UploadOutlined />}>
                    Subir Excel modificado
                  </ButtonItem>
                </Upload>
              </Col>
            </Row>

            {sinIdError && (
              <Alert
                type="error"
                showIcon
                message="El archivo no contiene la columna _id. Descargue el Excel desde este módulo y vuelva a intentarlo."
                style={{ marginBottom: 16 }}
              />
            )}

            {data.length > 0 && !sinIdError && (
              <>
                <Alert
                  type={errores > 0 ? "warning" : "success"}
                  showIcon
                  style={{ marginBottom: 12 }}
                  message={
                    <>
                      Se detectaron <b>{totalConCambios}</b> insumo(s) con
                      cambios en las columnas:{" "}
                      <b>{columnasAviso.join(", ")}</b>.
                      {errores > 0 && (
                        <>
                          {" "}Se omitieron <b>{errores}</b> fila(s) con
                          errores.
                        </>
                      )}
                    </>
                  }
                />
                {erroresBackend && erroresBackend.length > 0 && (
                  <Alert
                    type="error"
                    showIcon
                    style={{ marginBottom: 12 }}
                    message={`El backend rechazó ${erroresBackend.length} insumo(s):`}
                    description={
                      <ul style={{ margin: 0, paddingLeft: 20 }}>
                        {erroresBackend.map((e, idx) => {
                          const ins = this.state.insumosMap[String(e.insumoId)];
                          const clave = ins?.clave || e.insumoId;
                          return (
                            <li key={idx}>
                              <b>{clave}</b>: {e.motivo}
                            </li>
                          );
                        })}
                      </ul>
                    }
                  />
                )}
                <div
                  style={{
                    marginBottom: 8,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>
                    <Switch
                      checked={soloConCambios}
                      onChange={(v) => this.setState({ soloConCambios: v })}
                      size="small"
                    />{" "}
                    Mostrar solo con cambios ({totalConCambios} de {data.length})
                  </span>
                  {totalConCambios > 0 && (
                    <ButtonItem
                      type="primary"
                      onClick={this.onFinish.bind(this)}
                    >
                      Guardar cambios en {totalConCambios} insumo
                      {totalConCambios !== 1 ? "s" : ""}
                    </ButtonItem>
                  )}
                </div>
                <TableItem
                  size="small"
                  dataSource={dataMostrar}
                  columns={columns}
                  scroll={{ x: "max-content" }}
                  rowKey="insumoId"
                />
              </>
            )}
          </Spin>
        </div>
        <ModalProgreso
          visible={this.state.guardando}
          titulo="Guardando cambios"
          descripcion="No cierres esta ventana: el proceso sigue en el servidor, pero perderías el avance en pantalla. Los insumos se escriben por lotes para no saturar la base."
          procesados={this.state.progreso.procesados}
          total={this.state.progreso.total}
          unidad="insumos"
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EdicionMasivaInsumos);
